import axios from 'axios';
import { API_URL } from './ApiConfig';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor para adicionar token (se existir)
api.interceptors.request.use(
  config => {
    try {
      const storedToken = localStorage.getItem('token');
      const token = storedToken ? JSON.parse(storedToken) : null;

      if (token?.token) {
        config.headers.Authorization = `Bearer ${token.token}`;
      }
    } catch (error) {
      console.error('⚠️ Erro ao ler o token do localStorage:', error);
    }
    return config;
  },
  error => Promise.reject(error)
);

export default api;
